import { Pipe, PipeTransform } from '@angular/core';
import { CMS_END_POINTS } from '../const/api';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'pdf'
})
export class PdfPipe implements PipeTransform {

  constructor(private configService: ConfigService){}

  transform(file: string): string {
    if (!file) return '';
    return this.configService.baseURL + CMS_END_POINTS.GET_PDF + "?id=" + file;
  }

}
